import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import styleConstants from "../scss/_variables.module.scss";

export enum AvisDevice {
  "mobile",
  "tablet",
  "desktop",
}

const useDeviceDetection = () => {
  const [device, setDevice] = useState<AvisDevice>();

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      const isMobile =
        /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent) ||
        window.innerWidth < toInteger(styleConstants.tabletScreenWidthNumber);

      const isTablet =
        /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent) ||
        (window.innerWidth <
          toInteger(styleConstants.desktopScreenWidthNumber) &&
          window.innerWidth >=
            toInteger(styleConstants.tabletScreenWidthNumber));

      if (isMobile) {
        setDevice(AvisDevice.mobile);
      } else if (isTablet) {
        setDevice(AvisDevice.tablet);
      } else {
        setDevice(AvisDevice.desktop);
      }
    };

    handleDeviceDetection();
    window.addEventListener("resize", handleDeviceDetection);

    return () => {
      window.removeEventListener("resize", handleDeviceDetection);
    };
  }, []);

  return device;
};

export default useDeviceDetection;
